import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import * as serviceWorker from './serviceWorker';

const resizeObserverErr = 'ResizeObserver loop completed with undelivered notifications.';
window.addEventListener('error', e => {
  if (e.message === resizeObserverErr) {
    e.stopImmediatePropagation();
  }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

serviceWorker.unregister();